<template>
    <form
        novalidate
        onsubmit="return false;"
    >
        <slot></slot>
    </form>
</template>
